import "@fontsource-variable/archivo/wdth.css";
import "@fontsource-variable/geist-mono";
import "./styles/global.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { loadBrandLogos } from "./lib/brandLogos";
import { loadConfig } from "./auth/config";
import { ensureSignedIn, isPublicPath, setCurrentTenant } from "./auth/session";

/**
 * A link from Teams, Slack or an email names its workspace (?tenant=), so it opens there. The
 * workspace check that follows sign-in falls back to another of the person's workspaces when
 * they aren't in this one.
 */
function adoptTenantFromLink() {
  const url = new URL(window.location.href);
  const slug = url.searchParams.get("tenant");
  if (!slug) return;
  setCurrentTenant(slug);
  url.searchParams.delete("tenant");
  window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
}

async function start() {
  adoptTenantFromLink();
  // Brand logos load alongside sign-in, so screens rarely draw a fallback first.
  void loadBrandLogos();
  await loadConfig();
  // Sign-in, invites and password links open for anyone; everything else needs a sign-in.
  if (!isPublicPath(window.location.pathname) && !(await ensureSignedIn())) return;
  const root = document.getElementById("root");
  if (!root) throw new Error("Missing #root element");
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void start();
